import { Link } from "react-router-dom";
import { track } from "@/lib/marketplaceTrack";

export function ListingLink({ listing, className, children, testid, ...rest }) {
  const url = listing.destination_url || "#";
  const onClick = () => track("click", listing.id, url);
  if (/^https?:\/\//.test(url)) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" onClick={onClick} className={className} data-testid={testid} {...rest}>
        {children}
      </a>
    );
  }
  if (url.startsWith("#")) {
    return (
      <a href={url} onClick={onClick} className={className} data-testid={testid} {...rest}>{children}</a>
    );
  }
  return <Link to={url} onClick={onClick} className={className} data-testid={testid} {...rest}>{children}</Link>;
}
